(function() {
  function initQuickAddSizes() {
    document.addEventListener('click', function(e) {
      const btn = e.target.closest('.tshirt-size-pill, .tshirt-quick-direct-btn');
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      if (btn.disabled || btn.classList.contains('is-loading')) return;

      const variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;

      btn.classList.add('is-loading');

      const rootUrl = window.Shopify?.routes?.root || '/';

      const formData = {
        id: variantId,
        quantity: 1,
        sections: 'cart-drawer,cart-icon-bubble'
      };

      fetch(rootUrl + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(function(response) {
        if (!response.ok) {
          throw new Error('Add to cart failed');
        }
        return response.json();
      })
      .then(function(data) {
        btn.classList.remove('is-loading');
        btn.classList.add('is-success');

        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents(data);
        } else if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        }

        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'quick-add', cartData: data });
        }

        setTimeout(function() {
          btn.classList.remove('is-success');
        }, 1500);
      })
      .catch(function(error) {
        console.error('Quick add error:', error);
        btn.classList.remove('is-loading');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initQuickAddSizes);
  } else {
    initQuickAddSizes();
  }
})();
